export default function checkSession() {
  const session = localStorage.getItem('portal_weizman_session');
  if (session) {
    const jsonSession = JSON.parse(session);
    return jsonSession;
  }
  return null;
}
